import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ActionComponent } from 'projects/app-default/src/app/ui/api/action.component';
import { ResultComponent } from 'projects/app-default/src/app/ui/resut/result.component';
import { AccountBackComponent } from '../../../back/account-back.component';
import { AccountFormComponent } from '../../../form/account-form.component';

@Component({
    selector: 'account-edit-form-layout',
    templateUrl: './account-edit-form-layout.html',
    standalone: true,
    imports: [AccountBackComponent, AccountFormComponent, SizeClassDirective, TranslationModule, ActionComponent, ResultComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountEditFormLayoutComponent {
    @Input()
    inFormTitle: string = 'Default in form title';
    @Input()
    sectionTitle: string = 'Default section title';
    @Input()
    source?: any;
}
